<template>
	<div class="full">
		<el-container class="full">
			<el-aside width="180px">
				<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
					<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="warehouselist" collapse
						@item-click="itemClick" v-if="warehouselist.length!=0"></v-jstree>
				</div>
			</el-aside>
			<el-main style="padding: 2px;overflow: hidden;">
				<el-tabs class="tabs flex" v-model="activeName" type="border-card">
					<el-tab-pane label="应急" name="emergent" style="height: 100%;">
						<emergent-index :warehouseid="warehouseid" ref="emergentIndex" @purchasesuccess="reflash" />
					</el-tab-pane>
					<el-tab-pane label="备货" name="stockup" style="height: 100%;">
						<stockup-index :warehouseid="warehouseid" ref="stockupIndex" @purchasesuccess="reflash" />
					</el-tab-pane>
					<el-tab-pane label="自定义" name="custom" style="height: 100%;">
						<custom-index :warehouseid="warehouseid" @purchasesuccess="reflash" />
					</el-tab-pane>
				</el-tabs>
			</el-main>
		</el-container>
	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import VJstree from 'vue-jstree'
	import emergentIndex from './list/emergent.vue'
	import stockupIndex from './list/stockup.vue'
	import customIndex from './list/custom.vue'
	export default {
		props: {

		},
		data() {
			return {
				loading:false,
				activeName: 'emergent',
				warehouseid:null,
				warehouselist:[]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.list()
		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.warehouselist = []
				this.$api.stockwarning.listwarehouse().then((res) => {
					res.forEach((item,index)=>{
						if(index==0){
							item.selected = true
							this.warehouseid = item.id						
						}
					})
					this.warehouselist = res
					if(this.warehouselist.length){
						this.reflash()
					}
					this.loading = false
				},()=>{
					this.loading = false
				})
			},
			itemClick(e) {
				// console.log(e.model.id)
				this.warehouseid = e.model.id
				this.reflash()

			},
			reflash(){
				this.$nextTick(()=>{
					this.$refs.emergentIndex.getgrid().commitProxy('query')
					this.$refs.stockupIndex.getgrid().commitProxy('query')
				})
			}
		},
		components: {
			VJstree,
			emergentIndex,
			stockupIndex,
			customIndex
		}
	}
</script>